import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[arrowTooltip]',
  standalone: true
})
export class ArrowTooltipDirective {
  @Input('arrowTooltip') tooltipText: string | null = null;
  private tooltip: HTMLElement | null = null;
  private hideTimeout: any = null;

  constructor(private el: ElementRef) {}

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: MouseEvent) {
    
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    if (this.tooltip) return;
    
    if (!this.tooltipText) return;

    event.stopPropagation();

    this.tooltip = document.createElement('div');
    this.tooltip.className = 'custom-tooltip-container';
    
    this.tooltip.style.pointerEvents = 'none';
    this.tooltip.style.position = 'fixed';
    this.tooltip.style.zIndex = '10000';

    const textBox = document.createElement('div');
    textBox.className = 'custom-tooltip-box';
    textBox.textContent = this.tooltipText;
    this.tooltip.appendChild(textBox);

    const arrow = document.createElement('div');
    arrow.className = 'custom-tooltip-arrow';
    this.tooltip.appendChild(arrow);

    document.body.appendChild(this.tooltip);
    this.positionTooltip();

    setTimeout(() => {
      this.tooltip?.classList.add('show');
    }, 10);
  }

  @HostListener('mouseleave', ['$event'])
  onMouseLeave(event: MouseEvent) {    
    event.stopPropagation();
    
    this.hideTimeout = setTimeout(() => {
      if (this.tooltip) {
        this.tooltip.classList.remove('show');
        setTimeout(() => {
          if (this.tooltip) {
            document.body.removeChild(this.tooltip);
            this.tooltip = null;
          }
        }, 200);
      }
    }, 100);
  }

  private positionTooltip() {
    if (!this.tooltip) return;

    const hostRect = this.el.nativeElement.getBoundingClientRect();
    const tooltipRect = this.tooltip.getBoundingClientRect();

    const top = hostRect.top - tooltipRect.height - 10;
    const left = hostRect.left + (hostRect.width / 2) - (tooltipRect.width / 2);

    this.tooltip.style.top = `${top}px`;
    this.tooltip.style.left = `${left}px`;
  }

  ngOnDestroy() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    if (this.tooltip) {
      document.body.removeChild(this.tooltip);
    }
  }
}